import {
  TOUR_CUSTOMER_DETAILS_API_START,
  TOUR_CUSTOMER_DETAILS_API_SUCCESS,
  TOUR_CUSTOMER_DETAILS_API_ERROR,
  TOUR_OPERATOR_TOURS_API_START,
  TOUR_OPERATOR_TOURS_API_SUCCESS,
  TOUR_OPERATOR_TOURS_API_ERROR,
  TOUR_OPERATOR_RE_FLEET_START,
  TOUR_OPERATOR_RE_FLEET_SUCCESS,
  TOUR_OPERATOR_RE_FLEET_ERROR
} from "../Constant/CustomerDetailsConstant";

const initialState = {
  loading: false,
  tourCustomerDetails: [],
  tourOperatorAllTours: [],
  tourOperatorREfleets: []
};

export default function CustomerDetailsReducer(
  state = { ...initialState },
  action
) {
  switch (action.type) {
    case TOUR_CUSTOMER_DETAILS_API_START:
      return {
        ...state,
        loading: true,
        tourCustomerDetails: []
      };
    case TOUR_OPERATOR_TOURS_API_START:
      return {
        ...state,
        loading: true,
      };
    case TOUR_CUSTOMER_DETAILS_API_SUCCESS:
      return {
        ...state,
        tourCustomerDetails: action.payload,
        loading: false,
      };
    case TOUR_OPERATOR_TOURS_API_SUCCESS:
      return {
        ...state,
        tourOperatorAllTours: action.payload,
        loading: false,
      };
    case TOUR_CUSTOMER_DETAILS_API_ERROR:
    case TOUR_OPERATOR_TOURS_API_ERROR:
      return {
        ...state,
        loading: false,
        message: action.error.message,
      };
    case TOUR_OPERATOR_RE_FLEET_START:
      return {
        ...state,
        loading: true,
      };
    case TOUR_OPERATOR_RE_FLEET_SUCCESS:
      return {
        ...state,
        tourOperatorREfleets: action.payload,
        loading: false,
      };
    case TOUR_OPERATOR_RE_FLEET_ERROR:
      return {
        ...state,
        loading: false,
        message: action.error.message,
      };
    default:
      return state;
  }
}